import { getDefaultApi } from './ChinookApiService';

export const creerLiasseSouscription = valuesAenvoye => {
  return getDefaultApi()
    .creerLiasseSouscription(valuesAenvoye)
    .then((response) => response.data);
};

export const recupererUrlSignature = (uidLiasse, redirectUrl) => {
  return getDefaultApi()
    .recupererUrlSignature(uidLiasse, redirectUrl)
    .then((response) => response.data);
};

export const annulerLiasseSouscription = uidLiasse => {
  return getDefaultApi()
    .annulerLiasse(uidLiasse)
    .then((response) => response.data);
};
